"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/AlertList/AlertListProps.js
// module id = 1744
// module chunks = 8